import type { z } from "zod";

import instance from "../";
import { looseArray, looseParse } from "../looseParse";
import {
  achRelationshipSchema,
  bankRelationshipSchema,
  type plaidVerificationStatusSchema,
} from "./relationships.schema";

export type PlaidVerificationStatus = z.infer<
  typeof plaidVerificationStatusSchema
>;

export type ACHRelationship = z.infer<typeof achRelationshipSchema>;

type BankRelationship = z.infer<typeof bankRelationshipSchema>;

export type BankRelationships = BankRelationship[];

export type MutateBankRelationshipParams = {
  plaid: {
    public_token: string;
    account_id: string;
    name?: string;
    mask?: string;
    verification_status?: string;
  };
};

export const getBankRelationships = async (accountID: string) => {
  const { data } = await instance.get<BankRelationships>(
    `/accounts/${accountID}/relationships`,
  );
  return looseParse(
    looseArray(bankRelationshipSchema, "getBankRelationships"),
    data,
    "getBankRelationships",
  );
};
export const createBankRelationship = async (
  accountID: string,
  body: MutateBankRelationshipParams,
) => {
  const { data } = await instance.post<ACHRelationship>(
    `/accounts/${accountID}/relationships`,
    body,
  );

  return looseParse(achRelationshipSchema, data, "createBankRelationship");
};

export type VerifyBankRelationshipArgs = {
  accountID: string;
  relationshipID: string;
  body: MutateBankRelationshipParams;
};
export const verifyBankRelationship = async ({
  accountID,
  relationshipID,
  body,
}: VerifyBankRelationshipArgs) => {
  const { data } = await instance.post<ACHRelationship>(
    `/accounts/${accountID}/relationships/${relationshipID}/verify`,
    body,
  );

  return looseParse(achRelationshipSchema, data, "verifyBankRelationship");
};
